import React from "react";
import {useDispatch, useSelector} from "react-redux";
import TableHeader from "../../../core/Table/TableHeader/TableHeader.jsx";
import {GAME_CONVENTIONS, TOURNAMENT_TABLE_TITLES} from "../../../constants/index.jsx";
import {formatTimestamp, handleTournamentBuyIn} from "../../../utils/index.js";
import {useTranslation} from "react-i18next";
import {setSideBarTournamentId} from "../../../redux/actions/tournament/actions.js";
import combinedTournamentButtons from "../Buttons/TournamentButtons/index.jsx";
import {lobbyOpenModal} from "../../../redux/actions/lobby/actions.js";
import SafeDynamicComponent from "../SafeDynamicComponent.jsx";

function TournamentList() {
    const {t} = useTranslation();
    const {isMobile, currency, id, lang} = useSelector((state) => state.user);
    const list = useSelector(state => state.tournament.list);
    const rows = Object.values(list).sort((t1, t2) => t1?.info?.startDate - t2?.info?.startDate).map(tournament => ({row: tournament.rows}));
    const flattedConventions = GAME_CONVENTIONS.flat()
    const dispatch = useDispatch();
    const getTitle = (value) => {
        return flattedConventions.find(item => item.value === value)?.label
    }

    const handleTournamentItemClick = (tournamentId) => {
        dispatch(setSideBarTournamentId({tournamentId}))
    }

    const handleTournamentItemClickMobile = (tournamentId) => {
        dispatch(setSideBarTournamentId({tournamentId}))
        dispatch(lobbyOpenModal({name: 'TournamentInfoMobile'}))
    }

    const indicatorColor = (cells) => {
        const tournamentStatus = cells["table_tournament_status"];
        const tournamentPlayers = list?.[cells["table_tournament_id"]]?.players || {};
        const playerStatus = tournamentPlayers[id]?.status;
        if (tournamentStatus === "PENDING" || tournamentStatus === "PROGRESS") {
            if (!playerStatus || playerStatus === "FINISHED") return "green"
            if (playerStatus === "PENDING" || playerStatus === "PROGRESS") return "yellow"
        }
        if (tournamentStatus === "FINISHED" || tournamentStatus === "CANCELED") return "red"
    }

    const renderRow = (cells, index) => {
        const TournamentRowButton = combinedTournamentButtons[cells["table_tournament_status"]];
        const tournamentPlayers = list?.[cells["table_tournament_id"]]?.players || {};
        const tournamentPlayer = tournamentPlayers?.[id] || {};
        const tournament = list[cells["table_tournament_id"]];
        const betAmount = handleTournamentBuyIn(tournament?.info, currency, tournamentPlayer?.points);
        return <div key={index + 'tournament'} className={`table-body--row hover`}
                    onClick={() => handleTournamentItemClick(cells['table_tournament_id'])}>
            <div className="table-body--cell">{cells['table_tournament_name']}</div>
            <div className="table-body--cell">{betAmount}<span
                className="currency-small">{currency}</span>
            </div>
            <div className="table-body--cell">{cells['table_tournament_till']}</div>
            <div className="table-body--cell">
                <div className="table-body--cell--icons">
                    {
                        cells['table_tournament_type']?.map((item, index) => {
                            return <i
                                key={`icon-${item}${index}`}
                                className={`icon-${item} table-icon`}
                                title={t(`form.${getTitle(item)}`)}
                            />
                        })
                    }
                </div>
            </div>
            <div
                className="table-body--cell">{formatTimestamp(cells['table_tournament_start'], "time-monthName-day", lang)}</div>
            <div className="table-body--cell">
                {cells['table_tournament_prize'][currency]}
                <span className="currency-small">{' ' + currency}</span>
            </div>
            <div className="table-body--cell table-body--cell--buttons">
                <SafeDynamicComponent Component={TournamentRowButton} row={cells}/>
            </div>
        </div>
    }
    const renderRowMobile = (cells, key) => {
        const TournamentRowButton = combinedTournamentButtons[cells["table_tournament_status"]];
        const tournamentPlayers = list?.[cells["table_tournament_id"]]?.players || {};
        const tournamentPlayer = tournamentPlayers?.[id] || {};
        const tournament = list[cells["table_tournament_id"]]
        const betAmount = handleTournamentBuyIn(tournament?.info, currency, tournamentPlayer?.points,);
        return (
            <div
                key={key + 'tournament-mobile'}
                className={`mobile-tournament-list-item ${indicatorColor(cells)}`}
                onClick={() => handleTournamentItemClickMobile(cells['table_tournament_id'])}>
                <div className="mobile-tournament-list-item-left">
                    <div className="mobile-tournament-list-item-left__top">
                    <span className="text">
                       {cells["table_tournament_name"]}
                        <span>{formatTimestamp(cells["table_tournament_start"], "time-monthName-day", lang)}</span>
                       </span>
                        <span className="text text-amount">
                       {`${t('tournament.prize')} ${cells["table_tournament_prize"][currency]}`}
                    </span>
                    </div>
                    <div className="mobile-tournament-list-item-left__bottom">
                    <span className="text condition">
                        {cells["table_tournament_till"]}
                        {
                            cells["table_tournament_type"]?.map((item, index) => {
                                return <i
                                    key={`icon-${item}${index}`}
                                    className={`icon-${item} table-icon`}
                                />
                            })
                        }
                    </span>
                        <span className="text text-prize">
                        {`${t('tournament.bet')}: ${betAmount}`}
                            <span className='currency-small'> {currency}</span>
                    </span>
                    </div>
                </div>
                <div
                    className={`mobile-tournament-list-item-right ${indicatorColor(cells)}`}>
                    <SafeDynamicComponent Component={TournamentRowButton} row={cells}/>
                </div>
            </div>
        )
    }

    return <>
        {
            !isMobile
                ?
                <div className="table-wrapper">
                    <div className="tournament-list">
                        <div className="table">
                            <TableHeader columns={TOURNAMENT_TABLE_TITLES}/>
                            <div className="table-body">
                                {
                                    rows?.map((row, index) => {
                                        return renderRow(row?.row, index)
                                    })
                                }
                            </div>
                        </div>
                    </div>
                </div>
                :
                <div className="mobile-tournament-list">
                    {
                        rows?.map((row, index) => {
                            return renderRowMobile(row?.row, index)
                        })
                    }
                </div>
        }

    </>

}

export default TournamentList